import React from "react";
import {observer} from "mobx-react";

export const SmallSpinnerComponent: React.FC = observer(() => {
    return (
        <div></div>
    );
});

